/*
 * @Author: DT
 * @Date: 2022-10-19 09:38:52
 * @LastEditors: DT
 * @LastEditTime: 2022-11-09 19:11:02
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/returnGoods/pickingList/pickingList.js
 */
import { driverTakeDetailApi } from "@/libs/api";
export default {
  data() {
    return {
      listStatus: 1,
      listData: [],
    };
  },
  mounted() {
    window.dsBridge &&
      window.dsBridge.call("setNativeTitle", {
        title: "",
      });
    console.log("id=======", this.$route.query.id);
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    this.getList(this.$route.query.id);
  },
  methods: {
    getList(id) {
      driverTakeDetailApi({ id })
        .then((res) => {
          if (res.returnCode == "0000") {
            if (res.result && res.result.list) {
              this.listData = res.result.list;
              if (this.listData.length > 0) {
                this.listStatus = 2;
                this.listData.forEach((item) => {
                  item.showProductPic = item.productPic.split("|*|");
                });
              } else {
                this.listStatus = 3;
              }
            } else {
              this.listStatus = 3;
            }
          } else {
            this.listStatus = 3;
          }
          this.$toast.clear();
        })
        .catch(() => {
          this.listStatus = 3;
        });
    },
  },
};
